import { useState, useEffect, useContext } from 'react';
import { useParams } from "react-router-dom";
import axios from 'axios'
import useBreadcrumbs from 'use-react-router-breadcrumbs'
import { UserContext } from '../../context/user-context';

import { Breadcrumb } from 'react-bootstrap'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

// import RE_DonutChart from './components/rePieChart';
import CH_DonutChart from './ticketsGraphs/donutChart';
// import TicketsGraphs from './ticketsGraphs/ticketsGraphs';
import EventSalesChart from '../../components/eventSalesChart';
import { formatDate, formatCurrency } from '../../utils/utilities';
import EventSidebarLinks from '../../components/events/sidebar-links';
import AttendanceGeoLocations from '../../components/attendanceGeoLocations';

import './eventStats.css';

export default function EventStats() {
  const breadcrumbs = useBreadcrumbs();
  const { userToken, user } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [event, setEvent] = useState([]);
  const [visits, setVisits] = useState([]);
  const [visitConversionPercentage, setVisitConversionPercentage] = useState(0);
  const [attendanceData, setAttendanceData] = useState([]);
  const { event_id } = useParams();
  const [selectedTimePeriod, setSelectedTimePeriod] = useState('All Time');
  const [attendanceLocations, setAttendanceLocations] = useState([]);
  const [eventOrders, setEventOrders] = useState([]);
  const [totalSales, setTotalSales] = useState(0);
  const [percentScanned, setPercentScanned] = useState(0);
  const [ticketTypes, setTicketTypes] = useState([]);

  useEffect(() => {
    fetchStatsData();
    getEventSales();
  }, []);

  const fetchStatsData = async() => {
    // console.log('fetchStatsData called');
    try {
      const time = new Date().getTime();
      const [res_event, res_stats, res_attendance] = await Promise.all([
        axios.get(process.env.REACT_APP_API_BASE_URL + `/wp-json/gnetwork/v1/events/${event_id}?timestamp=${time}`, {
          headers: {
            'Authorization': 'Basic ' + btoa(user.user_login + ":" + userToken),
            'Content-Type': 'application/json',
          }
        }),
        axios.get(process.env.REACT_APP_API_BASE_URL + `/wp-json/gnetwork/v1/events/${event_id}/stats?timestamp=${time}`, {
          headers: {
            'Authorization': 'Basic ' + btoa(user.user_login + ":" + userToken),
            'Content-Type': 'application/json',
          }
        }),
        axios.get(process.env.REACT_APP_API_BASE_URL + `/wp-json/gnetwork/v1/events/${event_id}/attendance?timestamp=${time}`, {
          headers: {
            'Authorization': 'Basic ' + btoa(user.user_login + ":" + userToken),
            'Content-Type': 'application/json',
          }
        }),
      ]);
      if (res_event && res_stats && res_attendance) {
        const temp_event = res_event.data.data;
        const temp_stats = res_stats.data;
        const temp_attendance = res_attendance.data;
        // console.log(temp_event);
        // console.log('temp_stats', temp_stats);
        setEvent(temp_event);
        setTicketTypes(res_event.data.tickets);
        setVisits(temp_stats.visits);
        // Calc Visits Conversion %
        const total_visits = temp_stats.visits.length
        let converted_count = 0;
        temp_stats.visits.forEach(visit => {
          if (visit.converted == '1') {
            converted_count++;
          }
        });
        setVisitConversionPercentage((converted_count / total_visits) * 100);
        setAttendanceData(temp_attendance);
        // Scanned At
        const total_attendance = temp_attendance.attendance.length;
        const scanned_at_count = temp_stats.scanned_at.length;
        setPercentScanned((scanned_at_count / total_attendance) * 100);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }

  const getEventSales = async() => {
    try {
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + `/wp-json/gnetwork/v1/events/${event_id}/sales/`, {
        headers: {
          'Authorization': 'Basic ' + btoa(user.user_login + ":" + userToken),
          'Content-Type': 'application/json',
        },
      });
      // console.log('res data', res.data)
      if (res.data) {
        setEventOrders(res.data.orders);
        setTotalSales(res.data.total_sales);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      // setLoading(false);
    }
  }

  function eventStatusString( status ) {
    if (status) {
      return "Upcoming"
    } else {
      return "Ended"
    }
  }

  if (loading) {
    return (
      <Container className="event-stats-container py-3">
        <p>Loading...</p>
      </Container>
    );
  }

  return (
    <Container fluid className="p-relative">
      <EventSidebarLinks event={event}/>
      <Container className="event-stats-container py-3">
        {loading && (
          <p>Loading...</p>
        )}
        {<Breadcrumb>
          {breadcrumbs.map(({ breadcrumb, key, location, match }, index) => {
            breadcrumb = ((key === ('/events/' + event_id)) ? event?.post_title : breadcrumb);
            return (<Breadcrumb.Item key={index} href={key}>{breadcrumb}</Breadcrumb.Item>);
          })}
        </Breadcrumb>}
        {(!loading && event && attendanceData) && (
          <>
            <section className="event-stats-title py-3">
              <Row className="mb-3">
                <Col className="mb-3">
                  <h1 className="fs-1x">{event?.post_title ?? "N/a" } - Overview</h1>
                  <span>{event?.formatted_date?.split("-")[0] ?? "N/a"}</span>
                  <span>{eventStatusString(event?.is_upcoming ?? true)}</span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <h2 className="m-0">{event?.post_title} Dashboard</h2>
                </Col>
                <Col className="d-flex flex-row-reverse align-items-center">
                  <a href={`${process.env.REACT_APP_API_BASE_URL}/product/${event.post_name}`} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn btn-outline-secondary"
                  >View Event</a>
                </Col>
              </Row>
            </section>
            <section className="event-total-stats py-3">
              <Row style={{ rowGap: '1rem' }}>
                <Col xs="6" lg="3">
                  <div className="analytics-item">
                    <span>Revenue</span>
                    <div>
                      <span className="analytics-item_stat">{formatCurrency(totalSales)}</span>
                    </div>
                    <small className="text-silver">Total</small>
                  </div>
                </Col>
                <Col xs="6" lg="3">
                  <div className="analytics-item">
                    <span>Total RSVP</span>
                    <div>
                      <span className="analytics-item_stat">{event?.going_count}</span>
                    </div>
                    <small className="text-silver">Total</small>
                  </div>
                </Col>
                <Col xs="6" lg="3">
                  <div className="analytics-item">
                    <span>Referral Tracking Page Visits</span>
                    <div>
                      <span className="analytics-item_stat">{visits.length}</span>
                    </div>
                    <small className="text-silver">Total</small>
                  </div>
                </Col>
                <Col xs="6" lg="3">
                  <div className="analytics-item">
                    <span>Conversions</span>
                    <div>
                      <span className="analytics-item_stat">{visitConversionPercentage.toFixed(2)}%</span>
                    </div>
                    <small className="text-silver">Page visits to RSVP conversion</small>
                  </div>
                </Col>
              </Row>
            </section>
            <section>
              <Row>
                <Col lg="8">
                  <div className="overview-chart-container">
                    <Row className="mb-3">
                      <Col>
                        <h3>Overview</h3>
                        {/* <h3>Overview {selectedTimePeriod}</h3> */}
                      </Col>
                      {/* <Col>
                        <div className="time-period-options">
                          <Button 
                            variant={selectedTimePeriod == 'Today' ? 'outline-primary' : 'outline-secondary'}
                            onClick={() => {
                              setSelectedTimePeriod('Today')
                            }}
                          >Day</Button>
                          <Button
                            variant={selectedTimePeriod == 'This Week' ? 'outline-primary' : 'outline-secondary'}
                            onClick={() => {
                              setSelectedTimePeriod('This Week')
                            }}>Week</Button>
                          <Button 
                            variant={selectedTimePeriod == 'Month' ? 'outline-primary' : 'outline-secondary'}
                            onClick={() => {
                              setSelectedTimePeriod('Month')
                            }}
                          >Month</Button>
                          <Button 
                            variant={selectedTimePeriod == 'All Time' ? 'outline-primary' : 'outline-secondary'}
                            onClick={() => {
                              setSelectedTimePeriod('All Time')
                            }}
                          >All Time</Button>
                        </div>
                      </Col> */}
                    </Row>
                    <Row>
                      <Col>
                        <EventSalesChart event_id={event_id}/>
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col>
                  <h3>Orders</h3>
                  {(eventOrders.length > 0) && (
                    <ul className="event-orders">
                      {eventOrders.map((order, key) => {
                        return (
                          <li className="event-order" key={key}>
                            <div>
                              <h5 className="fs-1x">{order.billing_name}</h5>
                              <span>{formatDate(order.order_date)}</span>
                            </div>
                            <div className="text-right">
                              <span>Order #{order.ID}</span>
                              <span className="d-block fs-1.5x">{formatCurrency(order.order_total)}</span>
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </Col>
              </Row>
            </section>
            <section className="event-stats-tickets py-3">
              <Row>
                <Col>
                  <h3>Tickets</h3>
                  <p>Use the mobile app "Doorman Mode" to scan tickets (mark guests as attended). <a href="https://gnetworkclub.com/blog" target="_blank">Learn More</a></p>
                </Col>
              </Row>
              <Row style={{ rowGap: '1rem' }}>
                <Col lg="4">
                  <div className="analytics-item">
                    <span>Percent Scanned</span>
                    <div>
                      <span className="analytics-item_stat">{percentScanned.toFixed(2)}%</span>
                    </div>
                    <small>Total</small>
                  </div>
                </Col>
                {/* <Col lg="4">
                  <div className="analytics-item">
                    <span>Total Tickets Sold</span>
                    <div>
                      <span className="analytics-item_stat">0</span>
                    </div>
                    <p>To do: Add pie chart here, show the quantity sold of each ticket type</p>
                    <small>{ticketTypes.length} Ticket Types</small>
                  </div>
                </Col> */}
                <Col lg="4">
                  <div className="analytics-item">
                    <span>Ticket Types</span>
                    {ticketTypes.length > 0 && (
                      <ul className="ticket-types">
                        {ticketTypes.map((ticketType) => {
                          return (
                            <li className="d-flex justify-content-between">
                              <span>{ticketType.name}</span>
                              <span className="ticket-type-price">{formatCurrency(ticketType.price)}</span>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </div>
                </Col>
              </Row>
            </section>
            <section className="event-stats-attendance py-3">
              <Row>
                <Col>
                  <h3>Attendance</h3>
                </Col>
              </Row>
              <Row>
                <Col lg="6">
                  <div className="analytics-item">
                    <span>Gender Ratio</span>
                    <div>
                      <span className="analytics-item_stat">Female: {attendanceData?.female_count ?? 0}</span>
                      <br/>
                      <span className="analytics-item_stat">Male: {attendanceData?.male_count ?? 0}</span>
                    </div>
                    <CH_DonutChart chartData={{
                      "female": attendanceData?.female_count ?? 0,
                      "male": attendanceData?.male_count ?? 0,
                    }}/>
                  </div>
                </Col>
                <Col lg="6">
                  <div className="analytics-item">
                    <h4 className="fs-1x">Attendance Locations</h4>
                    <p className="text-silver">Attendance last logged in location.</p>
                    <AttendanceGeoLocations event_id={event_id} attendanceData={attendanceData}/>
                    {/* {!loading ? (
                      <>
                        {(attendanceData && attendanceData?.attendance && attendanceData?.attendance.length > 0) && (
                          <ul className="attendance-locations">
                            {attendanceData.attendance.map((attendee, key) => {
                              if (!attendee.ip_address) {
                                return <></>
                              }
                              return (
                                <li className="attendance-location" key={key}>
                                  <span>{attendee.ip_address}</span>
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </>
                    ) : (
                      <p>Attendance ip address data goes here.</p>
                    )} */}
                  </div>
                </Col>
              </Row>
            </section>
            {/*<TicketsGraphs/>*/}
          </>
        )}
      </Container>
    </Container>
  );
}
